var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',_vm._g({class:[
		'is-' + _vm.type,
		{
			'is-fullwidth': _vm.fullwidth,
			'is-small': _vm.small,
			sm_cobrowsing_masked_field: _vm.gliaMask,
			sm_cobrowsing_disabled_field: _vm.gliaDisable
		}
	],attrs:{"title":_vm.title,"href":_vm.url,"target":_vm.target,"disabled":_vm.disabled}},_vm.$listeners),[_vm._v(" "+_vm._s(_vm.title)+" "),(_vm.type === 'text')?_c('BaseIcon',{attrs:{"name":"arrow","color":"var(--darkGrey)","height":"28","width":"28","viewBox":"0 0 28 28"}},[_c('RightFacingArrowIcon')],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }